const CONTACT_ITEMS = [
  {
    icon: 'ri-map-pin-line',
    label: 'Address',
    value: 'Bulevar Makedonija bb',
  },
  {
    icon: 'ri-building-line',
    label: 'City',
    value: 'DELCEVO',
  },
  {
    icon: 'ri-mail-line',
    label: 'Zip Code',
    value: '2320',
  },
  {
    icon: 'ri-flag-line',
    label: 'Country',
    value: 'North Macedonia',
  },
  {
    icon: 'ri-mail-send-line',
    label: 'Email',
    value: 'help@delpakdoo.com',
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone Number',
    value: '+1 5055945301',
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="bg-gray-900 pt-24 pb-10 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">

          {/* Left: brand statement */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/a32dd7b7-57ba-4463-bfb3-ba4cc86f1f63.png"
              alt="DELPAK D.O.O. Logo"
              className="h-12 w-auto object-contain mb-6 brightness-200"
            />
            <p className="text-white text-3xl font-bold mb-4 leading-snug" style={{ fontFamily: "'Inter', sans-serif" }}>
              DELPAK D.O.O.
            </p>
            <p className="text-gray-400 text-base leading-relaxed max-w-sm">
              A team of iOS development experts building premium applications that
              enhance security, performance, and user experience on Apple devices.
              Headquartered in North Macedonia, serving users worldwide.
            </p>

            {/* Divider */}
            <div className="mt-10 h-px w-16 bg-teal-500" />
            <p className="text-teal-400 text-sm mt-4 font-medium">
              Crafting Premium iOS Solutions
            </p>
          </div>

          {/* Right: contact details */}
          <div>
            <p className="text-teal-400 text-xs font-semibold uppercase tracking-[0.25em] mb-8">
              Contact Information
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {CONTACT_ITEMS.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 rounded-lg bg-teal-500/10">
                    <i className={`${item.icon} text-teal-400 text-base`} />
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs font-medium uppercase tracking-wide mb-1">
                      {item.label}
                    </p>
                    <p className="text-gray-200 text-sm font-medium">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation row */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <nav className="flex flex-wrap gap-6">
            {['Home', 'About', 'Products', 'Contact'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.getElementById(item.toLowerCase());
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-gray-500 hover:text-teal-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                {item}
              </a>
            ))}
          </nav>
          <p className="text-gray-600 text-xs">
            &copy; {new Date().getFullYear()} DELPAK D.O.O. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}
